angular.module('unica_user.user_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// USER
		.state('app.user', {
			url: '/user',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/user/templates/user.html',
					controller: 'UserBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// USER LIST AND DELETE
			.state('app.user.list', {
				url: '/list',
				views: {
					'userContent': {
						templateUrl: './modules/user/templates/list.html',
						controller: 'UserListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Utenti'
				}
			})

			// USER CREATE
			.state('app.user.create', {
				url: '/create',
				views: {
					'userContent': {
						templateUrl: './modules/user/templates/create.html',
						controller: 'UserCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Aggiungi Utente',
					parent: 'app.user.list'
				}
			})


			// USER EDIT
			.state('app.user.edit', {
				url: '/edit/:id',
				views: {
					'userContent': {
						templateUrl: './modules/user/templates/edit.html',
						controller: 'UserEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Utente',
					parent: 'app.user.list'
				}
			})


			// USER EDIT - SECOND STEP
			.state('app.user.edit_second_step', {
				url: '/edit-second-step/:id',
				views: {
					'userContent': {
						templateUrl: './modules/user/templates/edit_second_step.html',
						controller: 'UserEditSecondStepController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Utente - Secondo Step',
					parent: function($scope) {
						return 'app.user.edit({id:' + $scope.user_id + '})';
					}
				}
			})


			// USER EDIT - THIRD STEP
			.state('app.user.edit_third_step', {
				url: '/edit-third-step/:id',
				views: {
					'userContent': {
						templateUrl: './modules/user/templates/edit_third_step.html',
						controller: 'UserEditThirdStepController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Utente - Terzo Step',
					parent: function($scope) {
						return 'app.user.edit_second_step({id:' + $scope.user_id + '})';
					}
				}
			})

	;


});

